var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction-container"},[_c('div',{staticClass:"error-message"}),_c('div',{staticClass:"atc-button",class:{ disabled: !_vm.activeProduct.available },on:{"click":() => _vm.handleClick()}},[_vm._v(" "+_vm._s(_vm.activeProduct.available ? _vm.ATC_TEXT : _vm.OUT_OF_STOCK_TEXT)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }